import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import React, { useMemo, useState } from 'react'

import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Label from "components/general/Label"
import MirsTable from "./table/Table";
import { ColumnRankNoType, ColumnName, ColumnNoc, ColumnResult } from "components/common/TableColumns"


function ColumnBib() {
    return (
        {
            Header: <Label data={'HeaderRaceNo'} />,
            accessor: 'athletes[0].bib',
            disableSort: true,
            className: 'text-end',
            headerClassName: 'text-end w-5',
            id: 'Bib'
        }
    )
}


export function getColumns() {
    return (
        [
            ColumnRankNoType({ disableSort: true }),
            ColumnBib(),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnResult({ disableSort: true }),


        ]
    )
}


function PhotoFinish({ data }) {

    const [show, setShow] = useState(false);
    const [contentData, setContentData] = useState({ modalPathImage: null, modalResults: null });
    const handleClose = () => setShow(false);
    const handleShow = (path, results) => {
        setContentData({ modalPathImage: path, modalResults: results })
        setShow(true);
    }
    const _columns = useMemo(() => getColumns(), []);

    const isOnePhotoFinish = data && data.length === 1 ? true : false;
    const labelPhotoFinish = Label({ data: "LabelPhotoFinish" })

    let imagePaths = [];
    let buttons = [];
    buttons = data && data?.sort((a, b) => a.picNumber - b.picNumber);
    const outButtons = buttons && buttons.map((item, index) => {
        imagePaths.push(item.imagePath);
        let arrayFilter = Array.isArray(item?.results) && item?.results?.filter(item => (item.resultRank))
        let min = Array.isArray(arrayFilter) && Math.min.apply(Math, arrayFilter.map(function (o) {
            return o.resultRank;
        }));
        let max = Array.isArray(arrayFilter) && Math.max.apply(Math, arrayFilter.map(function (o) {
            return o.resultRank;
        }));
        return (
            <Button key={`buttonsPhotoFinish-${index}`} variant="primary" onClick={() => handleShow(item.imagePath, item.results)} >
                <FontAwesomeIcon className="font-icon" icon={faCamera} /><br /> {!isOnePhotoFinish ? `${min}-${max}` : ''}
            </Button>
        )
    })


    return (
        <>
            <div className={"text-end"}>
                {outButtons}
            </div>
            <Modal centered size="lg" fullscreen={false} show={show} onHide={handleClose}>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className='d-block mx-auto img-fluid w-100'>
                                <picture ><img className="d-block mx-auto img-fluid h-100" alt={labelPhotoFinish} title={labelPhotoFinish} src={`${process.env.REACT_APP_SERVER_URL_RESOURCES}/img/${contentData.modalPathImage}`} /></picture>
                            </div>
                        </div>
                        {/*
                        <div class="col-md-12 mt-3 p-4">
                            {contentData.modalResults &&
                                < MirsTable
                                    className='table-photofinish'
                                    data={contentData.modalResults}
                                    //caption={<CaptionTable caption={data?.phase?.description} />}
                                    columns={_columns}
                                    id={`mirs-table-photo-finish-`}
                                    //keyRow='participant-code'
                                    initialSortBy={[{ id: 'RankNoType', desc: false }]}//Id of column

                                />
                            }
                        </div>
                        */}
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        <Label data={'LabelClose'} />
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );

}


export default PhotoFinish;